import React, { useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import useQueuePriorityWorkflowControlContext from "../../contexts/queue-priority-workflow-control-context";
import Style from "./FilteredLocationList.module.css";
import { ListHeader } from "../../components/list-header/ListHeader";
import { ListItem } from "../../components/list-item/ListItem";
import ListTable from "../../../../../../../../components/ListTable/ListTable";
import { STEP_ID_MAP } from "../../data/constants";
import useWorkOrderTrackPageDataSourceContext from "../../../../../../contexts/work-order-track-page-data-source-context";

export const FilteredLocationList = ({ optionControl }) => {
  const { sortPreferenceKey } = optionControl || {};

  const {
    setModalHeader,
    setModalFooterButtons,
    setCurrentStep,
    selectedLocationIds,
    setSelectedLocationIds,
    setPreviousStep
  } = useQueuePriorityWorkflowControlContext();
  const { locationTreeMap } = useWorkOrderTrackPageDataSourceContext();

  const header = () => {
    return (
      <div>
        <div className={Style.header_text}>Edit Sort Preferences Individually</div>
        <p className={Style.header_subtext}>Sort preferences created together can be individually or bulk edited</p>
      </div>
    );
  };

  useEffect(() => {
    setModalHeader(header);
    setModalFooterButtons([
      {
        id: "back",
        title: "Back",
        onClick: () => {
          setCurrentStep(STEP_ID_MAP.allLocationList);
        }
      }
    ]);
  }, []);

  const headersList = [
    { id: "name", label: "Location" },
    { id: "edit", label: "" }
  ];

  const filteredLocationList = useMemo(() => {
    return Object.values(locationTreeMap)
      .map((eachLocation) => {
        return eachLocation;
      })
      .filter((eachLocation) => {
        return eachLocation[sortPreferenceKey]?.length && selectedLocationIds.includes(eachLocation.id);
      })
      .sort((a, b) => {
        return (
          a.category.localeCompare(b.category, undefined, {
            numeric: true,
            sensitivity: "base"
          }) ||
          a.name.localeCompare(b.name, undefined, {
            numeric: true,
            sensitivity: "base"
          })
        );
      });
  }, [locationTreeMap, selectedLocationIds]);

  return (
    <div className={Style.container}>
      <div className={Style.list_container}>
        <ListTable
          header={headersList}
          headerContainerClassName={Style.table_header}
          renderHeader={(eachHeader) => {
            return (
              <ListHeader
                key={eachHeader.id}
                headerRowContainerClassName={Style.header_row_container}
                label={eachHeader.label}
                onClick={eachHeader.onClick}
              />
            );
          }}
          data={filteredLocationList}
          renderItem={(eachLocation) => {
            const displayList = headersList.map(({ id: headerId }) => {
              if (headerId === "edit") {
                return {
                  id: "edit",
                  label: (
                    <div
                      className={Style.edit_button}
                      onClick={() => {
                        setPreviousStep(STEP_ID_MAP.groupedLocationList);
                        setCurrentStep(STEP_ID_MAP.editSortPreference);
                        setSelectedLocationIds([eachLocation.id]);
                      }}
                    >
                      Edit
                    </div>
                  )
                };
              }

              return { id: `${eachLocation.id}${headerId}`, label: eachLocation[headerId] };
            });
            return (
              <ListItem
                key={eachLocation.id}
                itemContainerClassName={Style.header_row_container}
                item={displayList}
              />
            );
          }}
        />
      </div>
    </div>
  );
};

FilteredLocationList.defaultProps = {
  optionControl: {},
  onModalClose: () => {}
};

FilteredLocationList.propTypes = {
  onModalClose: PropTypes.func,
  optionControl: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    locationCategories: PropTypes.arrayOf(PropTypes.string),
    sortPreferenceKey: PropTypes.string,
    sortPreferenceAttributeMap: PropTypes.object,
    sortPreferenceSections: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        label: PropTypes.string,
        attributes: PropTypes.arrayOf(PropTypes.string)
      })
    )
  })
};
